import { ErrorMessage, Field, Formik } from 'formik'

import RadioButtonGroup from '../forms/fields/RadioButtonGroup'
import RadioButtonWrapper from '../forms/fields/RadioButtonWrapper'
import FieldWrapper from '../forms/FieldWrapper'
import Translation from '../Translation/cont/Translation'
import config from '../../config.json'
import MultiselectCheckboxCinemas from '../forms/fields/MultiselectCheckboxCinemas'
import { sanitizeFormInput, sanitizeFormOutput } from '../../functions/formFunctions'
import getDisabledClass from '../../functions/getDisabledClass'
import OverlaySubmitCancelButtons from '../overlay/presentational/OverlaySubmitCancelButtons'
import positionConfig from '../../attribute-position-config.json'
import RadioButton from '../forms/fields/SingleSelectRadiobutton'
import addFormikData from '../../functions/addFormikData'

const EditSelection = ({initValues, selectionId, validationSchema, editSelectionSettings, editSelectionAutoplay, cliCinemas, clientCinemaId, cliCinemasIdList, styleOptions, editDisabled, onSubmit, onCancel}) => {
    const {destinationType, pathType} = positionConfig
    const cinemaDomain = cliCinemas[clientCinemaId].website
    
    return (
        <Formik
            initialValues={sanitizeFormInput(initValues)}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
                if(!values.link.url || !values.link.text) {
                    addFormikData(values, "", "link")
                }

                if(editDisabled) {
                    return false
                }

                onSubmit(sanitizeFormOutput(values))
                actions.setSubmitting(false);
                onCancel()
            }}
        >
            {({values, handleSubmit, setFieldValue}) => (
                <form 
                    className="overlay-form edit-selection-settings"
                    onSubmit={handleSubmit}
                >                
                    <div className="left-sections">
                        <FieldWrapper label={<Translation id="content_title"/>} id="title" classes="field-text gap-20">
                            <Field type="text" name="title" id="title" className="text-regular input-text-box" />
                            <ErrorMessage name="title" component="div" /> 
                        </FieldWrapper>

                        <p>Element ID: {selectionId && selectionId}</p>

                        {_.has(values, "cinema") && cliCinemas ? (
                            cliCinemasIdList.length > 1 ? (
                                <fieldset className="field-cinemas">
                                        <legend className="field-text-label"><Translation id="content_cinemas"/></legend>                                                
                                        <div className="select-all-cinemas-button-wrapper">  
                                            <div key={'field-all'} className="field-checkbox">
                                                <Field 
                                                    key={'all'} 
                                                    attrid={'all'}
                                                    name="cinemas"
                                                    component={MultiselectCheckboxCinemas} 
                                                    id={'alle anwählen'}
                                                    clicinemas={'all'}
                                                    value={cliCinemasIdList} 
                                                />
                                            </div>
                                        </div>

                                        <div className="grid-container">
                                            {cliCinemasIdList.map(cinemaId => {
                                                const cinema = cliCinemas[cinemaId]
                                                const {pk, nameShort} = cinema

                                                return (
                                                    <div key={'field' + pk} className="field-checkbox">
                                                        <Field 
                                                            key={pk} 
                                                            attrid={pk}
                                                            name="cinemas"
                                                            component={MultiselectCheckboxCinemas} 
                                                            id={nameShort}
                                                            clicinemas={cliCinemas}
                                                            value={pk}
                                                        />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </fieldset>
                                ) : (
                                    cliCinemasIdList.map(cinemaId => {
                                        const cinema = cliCinemas[cinemaId]
                                        const {pk, nameShort} = cinema
                                        
                                        return (
                                            <div key={'field' + pk} className="field-checkbox">
                                                <Field 
                                                    key={pk} 
                                                    attrid={pk}
                                                    name="cinemas"
                                                    component={MultiselectCheckboxCinemas} 
                                                    id={nameShort}
                                                    clicinemas={cliCinemas}
                                                    value={pk} 
                                                />
                                            </div>
                                        )
                                    })
                                )
                            ) : (
                                ''
                            )
                        }
                        {editSelectionSettings &&
                        <>
                            <RadioButtonGroup
                                label={<Translation id="selection_style_choose_label"/>}
                                description={<Translation id={"selection_style_description_" + values.type}/>}
                                className="select-new-style-type"
                            >
                                <ErrorMessage className="text-regular-color movie-error" name="style" component="div" /> 

                                {styleOptions.map(({transId, id}) => (
                                    <RadioButtonWrapper 
                                        key={id} 
                                        id={id} 
                                        label={<Translation id={transId}/>}
                                    >
                                        <Field
                                            id={id}
                                            type="radio"
                                            name="style"
                                            value={id}
                                        />

                                    </RadioButtonWrapper>
                                ))}
                            </RadioButtonGroup>

                            {editSelectionAutoplay && <RadioButtonGroup
                                label={<Translation id="selection_trailer_autoplay_label"/>}
                                description=""
                                className="select-new-section-type"
                            >
                                <ErrorMessage className="text-regular-color movie-error" name="trailerAutoplay" component="div" /> 

                                {config.sectionSettings.autoplayTypes.map(({transId, id}) => (
                                    <RadioButtonWrapper
                                        key={id} 
                                        id={id} 
                                        label={<Translation id={transId}/>}
                                    >
                                        <Field
                                            id={id}
                                            type="radio"
                                            name="trailerAutoplay"
                                            value={id}
                                        />
                                    </RadioButtonWrapper>

                                ))}
                            </RadioButtonGroup>}
                        </>
                        }
                        {values.style === "CustomButton" && <div className='field-text'>
                            <FieldWrapper label={<Translation id="content_link_text"/>} id="content-link-text" classes="field-text">
                                <Field type="text" name="link.text" id="content-link-text" className="text-regular input-text-box" />
                                <ErrorMessage name="link.text" component="div" /> 
                            </FieldWrapper>

                            <FieldWrapper label={<Translation id="content_link_url"/>} id="content-link-url" classes="field-text">
                                <Field type="text" name="link.url" id="content-link-url" className="text-regular input-text-box" />
                                <ErrorMessage name="link.url" component="div" /> 
                            </FieldWrapper>
                            <RadioButtonGroup
                                label={<Translation id="content_link_target"/>}
                                description={<Translation id="content_link_target_info"/>}
                                className="select-new-section-type field-text"
                            >
                                <ErrorMessage className="text-regular-color movie-error" name="link.destinationType" component="div" /> 
                                {destinationType.map(type => {
                                    const {transId, id} = type
                                    return (
                                        <Field
                                            key={id}
                                            component={RadioButton}
                                            setFieldValue={setFieldValue}
                                            name="link.destinationType"
                                            id={id}
                                            label={<Translation id={transId}/>}
                                            />
                                        )
                                    })}
                            </RadioButtonGroup>
                            <RadioButtonGroup
                                label={<Translation id="content_link_type"/>}
                                description={<Translation id="content_link_type_info" after={' ' + cinemaDomain}/>}
                                className="select-new-section-type field-text"
                                >
                                <ErrorMessage className="text-regular-color movie-error" name="link.pathType" component="div" /> 
                                {pathType.map(type => {
                                    const {transId, id} = type
                                    return (
                                        <Field
                                            key={id}
                                            component={RadioButton}
                                            setFieldValue={setFieldValue}
                                            name="link.pathType"
                                            id={id}
                                            label={<Translation id={transId}/>}
                                        />
                                    )
                                })}
                            </RadioButtonGroup>
                        </div>}
                    </div>

                    <OverlaySubmitCancelButtons
                        editDisabled={editDisabled}
                        onClose={onCancel}
                    />
                    
                </form>
            )}
        </Formik>
    );
}

export default EditSelection